import {requests} from "../../helpers/api.services";
import {BRAND_SETTINGS_URL} from "../../helpers/api.routes";

export const AdminBrandSettingsService = {
    get: () => requests.get(BRAND_SETTINGS_URL),
    create: (params: any) => requests.post(BRAND_SETTINGS_URL, params)
}